import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AgentDto } from '../../../../service/dto';
import { Callback } from '../../login.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../../../service/auth.service';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
	selector: 'app-forgot-password-form',
	standalone: false,
	templateUrl: './forgot-password-form.component.html',
	styleUrl: './forgot-password-form.component.scss'
})
export class ForgotPasswordFormComponent {
	@Input() agent!: AgentDto;
	@Output("doUpdateState") doUpdateState = new EventEmitter<Callback>();
	mode: 'CaptureUsername' | 'ResetPassword' = 'CaptureUsername';

	form: FormGroup;
	showPassword = false;
	showConfirmPassword = false;
	message?: string;

	constructor(private fb: FormBuilder, private authService: AuthService, private messageService: NzMessageService) {
		this.form = this.fb.group({
			username: ['', Validators.required],
			otp: ['', Validators.required],
			password: ['', Validators.required], //Check password strength
			passwordConfirm: ['', Validators.required]
		});
	}
	doSendOtp() {
		this.authService.sendForgotPasswordOtp(this.form.get('username')!.value).subscribe(item => {
			this.mode = 'ResetPassword'
		});
	}
	doResetPassword() {
		const username = this.form.get('username')!.value;
		const password = this.form.get('password')!.value;
		const otp = this.form.get('otp')!.value;
		this.message=undefined;

		this.authService.doResetPasswordForForgotPassword(username, password, otp).subscribe(item => {
			if (item.result == 'Valid') {
				this.messageService.info("Password successfully reset.")
				this.doUpdateState.emit({ mode: 'Login' });
				return;
			}
			if (item.result == 'Invalid') {
				this.message = item.message;
				return;
			}
			if (item.result == 'Expired') {
				this.messageService.error(item.message??'OTP has expired');
				this.doUpdateState.emit({ mode: 'Login' });
				return;
			}
			if (item.result == 'MaxAttemptsReached') {
				this.messageService.error(item.message??'Max attempts reached');
				this.doUpdateState.emit({ mode: 'Login' });
				return;
			}
			if (item.result == 'AlreadyUsed') {
				this.messageService.error(item.message??'OTP has already been used');
				this.doUpdateState.emit({ mode: 'Login' });
				return;
			}
		});
	}

	togglePasswordVisibility(): void {
		this.showPassword = !this.showPassword;
	}
	toggleConfirmPasswordVisibility(): void {
		this.showConfirmPassword = !this.showConfirmPassword;
	}
}
